import { Tooltip } from 'bootstrap'

export function setUpTooltips() {
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
    new Tooltip(el)
  })
}
